// extracted by mini-css-extract-plugin
export default {"popup_container":"modal_popup_popup_container__j3IeQ","popup_body":"modal_popup_popup_body__VILJs"};